import api from "../api"
export default {
	async getTransaction(transactionID) {
		let value = await api.get(`/transactions/${transactionID}`)
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		if (!value?.data?.data || !Array.isArray(value.data.data) || value.data.data.length === 0) {
			throw new Error("Transaction not found or invalid response")
		}
		let data = value.data.data[0]
		return data
	},
	async addTransaction(values) {
		let value = await api.post(`/transactions`, {
			...values,
		})
		if (!value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return value.data.data[0]
	},
	async editTransaction(values) {
		let value = await api.post(`/transactions/`, {
			...values,
		})
		if (!value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return value.data.data[0]
	},
	async editAction(transactionID, actionID, values) {
		let value = await api.put(
			`/transactions/${transactionID}/actions/${actionID}`,
			{
				...values,
			}
		)
		if (!value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return value.data.data[0]
	},
	async getTransactionList(limit, offset, role, params) {
		let value = await api.get(
			`/transactions/?limit=${limit}&offset=${offset}&role=${role}`,
			{ params }
		)
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		let data = value.data
		return data
	},
	async getFilteredTransactionList(limit, offset, filter, role) {
		let value = await api.get(
			`/transactions/?limit=${limit}&offset=${offset}&role=${role}&status=${filter}`
		)
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		let data = value.data
		return data
	},
	async searchTransaction(limit, offset, role, params) {
		let value = await api.get(`/transactions/`, {
			params: {
				limit,
				offset,
				role,
				...params,
			},
		})
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		let data = value.data
		return data
	},
	async getTransactionWithParams(params) {
		let value = await api.get(`/transactions/`, {
			params: {
				...params,
			},
		})
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		let data = value.data.metadata.pagination.totalRecords
		return data
	},
	async getTransactionDashboard() {
		let value = await api.get(`/transactions/dashboard`)
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		let data = value.data.data
		return data
	},
	async downloadPDF(rawLink, id) {
		let path = rawLink.replace("::id::", id)
		let response = await api.get(path, {
			responseType: "blob",
			headers: {
				"Content-Type": "application/json",
				"Accept": "application/pdf"
			}
		})

		const url = window.URL.createObjectURL(new Blob([response.data]))
		const link = document.createElement("a")
		link.href = url
		link.setAttribute("target", "_blank")
		link.setAttribute("download", `Transaction_${id}.pdf`)
		document.body.appendChild(link)
		link.click()
		document.body.removeChild(link)
	},
}
